<template>
	<div :class="{ 'not-icon': !showIcon }">
		<InputTextbox
			v-model:saturn="maskedPhone"
			:label="label"
			:placeholder="maskPlaceholder"
			:readonly="readonly"
			:disabled="disabled"
			:invalid="invalid"
			:type="'type' in $props ? type : 'text'"
			:infoIconObj="infoIconObj"
			:pattern="pattern"
			:comparer="comparer"
			:multiline="multiline"
			:showIcon="showIcon"
			:minlength="Number(minlength)"
			:maxlength="17"
			:icon="tempIcon"
			:copy="copy"
			:get="get"
			:set="set"
			:cssClass="cssClass"
			:height="height"
			:width="width"
			@focus="onFocusInput"
			@blur="onBlurHandler"
			@input="onInputHandler"
			@change="onChangeHandler"
		>
			<template
				v-if="util.hasKey($slots, 'validation')"
				#validation
			>
				<slot name="validation"></slot>
			</template>
			<template
				v-if="util.hasKey($slots, 'action')"
				#action
			>
				<slot name="action"></slot>
			</template>
		</InputTextbox>
	</div>
</template>

<script>
	import InputTextbox from '@core/components/InputTextbox.vue';
	import twoWayBind from '@core/services/two-way-bind';
	import util from '@core/services/util';
	import vstore from '@core/services/vstore';

	export default {
		name: 'InputPhone',
		emits: ['blur', 'change', 'focus', 'input', 'update:saturn'],
		props: [
			'saturn',
			'cdk',
			'label',
			'placeholder',
			'invalid',
			'readonly',
			'disabled',
			'multiline',
			'cssClass',
			'copy',
			'comparer',
			'get',
			'set',
			'maxlength',
			'minlength',
			'type',
			'pattern',
			'showIcon',
			'icon',
			'infoIconObj',
			'width',
			'height',
		],
		data() {
			return {
				vstore: vstore.state,
				vm: {
					saturn: null,
					cdk: null,
				},
				errorHover: false,
				wantIcon: null,
				maskedPhone: null,
				maskPlaceholder: '+1 (XXX) XXX-XXXX',
				previousValue: null,
			};
		},
		computed: {
			util() {
				return util;
			},
		},
		mounted() {
			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true, immediate: true },
			);
		},
		created() {
			this.init();
			this.tempIcon = 'fas fa-phone';
		},
		methods: {
			onFocusInput() {
				this.$emit('focus');
			},
			onBlurHandler($e) {
				this.$emit('blur', $e);
			},
			isNull(val) {
				if (val === null) {
					return '';
				} else {
					return val;
				}
			},
			unMaskValue(value) {
				let letter = false;
				this.previousValue = this.vm.saturn;
				let output = '';
				if (!util.isNull(value) && value.length > 1) {
					for (let i = 0; i < value.length; i++) {
						if (i == 0) {
							value = value.substring(3);
						}
						if (value[i] && value[i] != '(' && value[i] != ')' && value[i] != '-' && value[i] != '_' && value[i] != ' ') {
							if (!util.isNull(value[i])) {
								if (value[i].match(/[^0-9]/i)) {
									letter = true;
								} else {
									output += value[i];
								}
							}
						}
					}
				} else if (!value?.match(/[^0-9]/i)) {
					output = value;
				}
				if (this.previousValue == output && !letter) {
					output = output.substring(0, 2);
				}
				return output;
			},
			init() {
				this.vm.saturn = this.set ? this.set(this.saturn) : this.saturn;
				this.vm.cdk = this.cdk;
				this.maskedPhone = this.maskValue(this.vm.saturn);
				this.maskPlaceholder = this.placeholder ? this.placeholder : this.maskPlaceholder;
			},
			maskValue(value) {
				if (!util.isNull(value)) {
					let output = '';
					for (let i = 0; i < value.length; i++) {
						if (i == 0) {
							output = '+1 (' + value[i];
						} else if (i == 2) {
							output += value[i] + ') ';
						} else if (i == 6) {
							output += '-' + value[i];
						} else {
							output += value[i];
						}
					}
					return output;
				}
			},
			onInputHandler(val) {
				let realNumber = this.unMaskValue(val?.toUpperCase() ?? '');
				this.vm.saturn = realNumber;
				this.maskedPhone = this.maskValue(realNumber);

				if (!this.get) {
					this.$emit('update:saturn', this.vm.saturn);
					this.$emit('input', this.vm.saturn);
				}
			},
			onChangeHandler(val) {
				this.$emit('change', val);
			},
		},
		components: {
			InputTextbox,
		},
	};
</script>
